import React, { useEffect, useState } from "react";
import { Grid, Button, Card, CardContent, Collapse, Box, Chip, Badge, Paper, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DateRangeTableMission from './DateRangeTableMission'; 
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import PlanningMissionService from "../../../services/PlanningMissionService";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Message from "../../tools/Message";
import TableViewIcon from '@mui/icons-material/TableView';
import ExcelJS from 'exceljs';
import UserService from "../../../services/UserService";
import Typography from '@mui/material/Typography';
import { LoadingButton } from '@mui/lab';
import LoadingWithText from "../../tools/LoadingWithText";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PendingIcon from '@mui/icons-material/Pending';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import LocalisationMisService from "../../../services/LocalisationMisService";

const useStyles = makeStyles((theme) => ({
  filterCard: {
    marginBottom: theme.spacing(3),
    borderRadius: '16px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  statCard: {
    transition: 'all 0.3s ease',
    borderRadius: '16px',
    overflow: 'hidden',
    position: 'relative',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
    },
  },
  statIcon: {
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    opacity: 0.15,
    fontSize: '4rem',
  },
  statValue: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(0.5),
  },
  statLabel: {
    fontSize: '0.875rem',
    fontWeight: 500,
    opacity: 0.85,
  },
  infoBox: {
    backgroundColor: '#e3f2fd',
    borderRadius: '8px',
    padding: '12px',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
}));

function MissionList(props) {
  const classes = useStyles();
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);
  const [statistique, setStatistique] = useState([]);
  const [filtersExpanded, setFiltersExpanded] = useState(true);
  const [filter, setFilter] = useState({
    date_debut: '',
    date_fin: '',
    direction: [],
    destination: '',
    status: '',
    ligne: "missionaire",
    valeur: "direction",
    directionmiss: [],
    servicemiss: "",
    functionid: [],
    reference: '',
    region: '',
    district: '',
    commune: ''
  });
  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;
  const [valdir, setValdir] = useState([]);
  const [direction, setDirection] = useState([]);
  const [directiondest, setDirectiondest] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [service, setService] = useState([]);
  const [direcdetail, setDirect] = useState({});
  const [servicedet, setServicedet] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [datatable, setDatatable] = useState([]);
  const [defaultDirection, setDefaultDirection] = useState(null);
  const options = [
    { id: 'En attente de validation', label: 'En attente de validation' },
    { id: "validé", label: 'Validé' },
    { id: 'Refusé', label: 'Refusé' },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [listefonction, setListefonction] = useState([]);
  const [selectedFunctions, setSelectedFunctions] = useState([]);
  
  // États pour les sélections actuelles (affichage dans les chips)
  const [selectedDirection, setSelectedDirection] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null); 
  
  // États pour la localisation
  const [allRegions, setAllRegions] = useState([]);
  const [filteredRegions, setFilteredRegions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [communes, setCommunes] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedCommune, setSelectedCommune] = useState(null);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingCommunes, setLoadingCommunes] = useState(false);

  // Compter les filtres actifs
  const getActiveFiltersCount = () => {
    let count = 0;
    if (filter.reference) count++;
    if (filter.date_debut && filter.date_fin) count++;
    if (filter.directionmiss && filter.directionmiss !== 'all' && filter.directionmiss.length > 0) count++;
    if (filter.servicemiss) count++;
    if (filter.direction && filter.direction.length > 0) count++;
    if (filter.status) count++;
    if (filter.functionid && filter.functionid.length > 0) count++;
    if (filter.region) count++;
    if (filter.district) count++;
    if (filter.commune) count++;
    return count;
  };

  // Supprimer un filtre spécifique
  const removeFilter = (filterName) => {
    switch (filterName) {
      case 'reference':
        setFilter({ ...filter, reference: '' });
        break;
      case 'dates':
        setFilter({ ...filter, date_debut: '', date_fin: '' });
        break;
      case 'direction':
        setFilter({ ...filter, directionmiss: [] });
        setSelectedDirection(null);
        setService([]);
        break;
      case 'service':
        setFilter({ ...filter, servicemiss: "" });
        setSelectedService(null);
        break;
      case 'directiondest':
        setFilter({ ...filter, direction: [] });
        setValdir([]);
        break;
      case 'status':
        setFilter({ ...filter, status: '' });
        setSelectedStatus(null);
        break;
      case 'function':
        setFilter({ ...filter, functionid: [] });
        setSelectedFunctions([]);
        break;
      case 'region':
        setFilter({ ...filter, region: '', district: '', commune: '' });
        setSelectedRegion(null);
        setSelectedDistrict(null);
        setSelectedCommune(null);
        setDistricts([]);
        setCommunes([]);
        break;
      case 'district':
        setFilter({ ...filter, district: '', commune: '' });
        setSelectedDistrict(null);
        setSelectedCommune(null);
        setCommunes([]);
        break;
      case 'commune':
        setFilter({ ...filter, commune: '' });
        setSelectedCommune(null);
        break;
      default:
        break;
    }
  };

  function handleChange(event) {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });
  }

  function handleChangeDirdestination(event, value) {
    const safeValue = value || [];
    setValdir(safeValue);
    const iddir = safeValue.map(item => item.direction_id);
    setFilter({ ...filter, direction: iddir });
  }

  function handleChangeservice(event, value) {
    if (!value) {
      setServicedet({});
      setSelectedService(null);
      setFilter({
        ...filter,
        servicemiss: ""
      });
      return;
    }
    setServicedet(value);
    setSelectedService(value);
    setFilter({
      ...filter,
      servicemiss: value.service_id
    });
  }

  function handleChangeDirection(event, value) {
    if (!value) {
      // Cas où l'utilisateur efface la sélection
      setSelectedDirection(null);
      setDirect({});
      setService([]);
      setServicedet({});
      setSelectedService(null);
      setFilter({
        ...filter,
        directionmiss: [],
        servicemiss: ""
      });
      return;
    }

    setSelectedDirection(value);
    const directionIds = [value.direction_id];
    const hasAllOption = value.direction_id === 'all';
    
    if (hasAllOption) {
      setFilter({
        ...filter,
        directionmiss: "all"
      });
      PlanningMissionService.getServicelist("all").then((result) => {
        if (result && result.data) {
          setService(result.data);
        }
      });
    } else {
      setFilter({
        ...filter,
        directionmiss: directionIds
      });
      setDirect(value);
      
      PlanningMissionService.getServicelist(directionIds).then((result) => {
        if (result && result.data) {
          setService(result.data);
        }
      });
    }
  }

  const handleChangefunction = (event, newValue) => {
    const safeValue = newValue || [];
    setSelectedFunctions(safeValue);
    const functionIds = safeValue.map(func => func.function_id);
    setFilter({
      ...filter,
      functionid: functionIds
    });
  };

  // Gestionnaire pour le statut en sélection simple
  const handleChangestatus = (event, newValue) => {
    setSelectedStatus(newValue);
    setFilter({ ...filter, status: newValue ? newValue.id : '' });
  };

  // Gestionnaires pour la localisation
  const handleChangeRegion = async (event, newValue) => {
    setSelectedRegion(newValue);
    const regionId = newValue?.id_region || '';
    
    setFilter(prev => ({ 
      ...prev, 
      region: regionId, 
      district: '', 
      commune: '' 
    }));
    
    setSelectedDistrict(null);
    setSelectedCommune(null);
    setCommunes([]);
    
    if (regionId) {
      setLoadingDistricts(true);
      try {
        if (datatable && datatable.length > 0) {
          const uniqueDistricts = extractUniqueDistricts(datatable, regionId);
          setDistricts(uniqueDistricts);
        } else {
          const result = await LocalisationMisService.getDistrictByRegion(regionId);
          if (result && result.data) {
            setDistricts(result.data);
          } else {
            setDistricts([]);
          }
        }
      } catch (error) {
        console.error('Error fetching districts:', error);
        setDistricts([]);
      } finally {
        setLoadingDistricts(false);
      }
    } else {
      setDistricts([]);
    }
  };
  
  const handleChangeDistrict = async (event, newValue) => {
    setSelectedDistrict(newValue);
    const districtId = newValue?.id_district || '';
    
    setFilter(prev => ({ 
      ...prev, 
      district: districtId, 
      commune: '' 
    }));
    
    setSelectedCommune(null);
    
    if (districtId) {
      setLoadingCommunes(true);
      try {
        if (datatable && datatable.length > 0) {
          const uniqueCommunes = extractUniqueCommunes(datatable, districtId);
          setCommunes(uniqueCommunes);
        } else {
          const result = await LocalisationMisService.getCommune(districtId);
          if (result && result.data) {
            setCommunes(result.data);
          } else {
            setCommunes([]);
          }
        }
      } catch (error) {
        console.error('Error fetching communes:', error);
        setCommunes([]);
      } finally {
        setLoadingCommunes(false);
      }
    } else {
      setCommunes([]);
    }
  };
  
  const handleChangeCommune = (event, newValue) => {
    setSelectedCommune(newValue);
    const communeId = newValue?.id_commune || '';
    setFilter(prev => ({ ...prev, commune: communeId }));
  };

  const extractUniqueRegions = (data) => {
    const uniqueRegions = new Map();
    data.forEach(item => {
      let regionObj = null;
      if (item.region && typeof item.region === 'object') {
        regionObj = item.region;
      } else if (item.region && typeof item.region === 'string') {
        try {
          regionObj = JSON.parse(item.region);
        } catch (e) {}
      }
      
      if (regionObj && regionObj.id_region && !uniqueRegions.has(regionObj.id_region)) {
        uniqueRegions.set(regionObj.id_region, {
          id_region: regionObj.id_region,
          nom_region: regionObj.nom_region
        });
      }
    });
    return Array.from(uniqueRegions.values());
  };

  const extractUniqueDistricts = (data, selectedRegion) => {
    if (!selectedRegion) return [];
    
    const uniqueDistricts = new Map();
    data.forEach(item => {
      let itemRegion = null;
      if (item.region && typeof item.region === 'object') {
        itemRegion = item.region;
      } else if (item.region && typeof item.region === 'string') {
        try {
          itemRegion = JSON.parse(item.region);
        } catch (e) {}
      }
      
      if (itemRegion && itemRegion.id_region === selectedRegion) {
        let districtsArray = [];
        if (item.district && typeof item.district === 'string') {
          try {
            districtsArray = JSON.parse(item.district);
          } catch (e) {}
        } else if (Array.isArray(item.district)) {
          districtsArray = item.district;
        }
        
        districtsArray.forEach(district => {
          if (district && district.id_district && !uniqueDistricts.has(district.id_district)) {
            uniqueDistricts.set(district.id_district, {
              id_district: district.id_district,
              nom_district: district.nom_district
            });
          }
        });
      }
    });
    return Array.from(uniqueDistricts.values());
  };

  const extractUniqueCommunes = (data, selectedDistrict) => {
    if (!selectedDistrict) return [];
    
    const uniqueCommunes = new Map();
    data.forEach(item => {
      let communesArray = [];
      if (item.commune && typeof item.commune === 'string') {
        try {
          communesArray = JSON.parse(item.commune);
        } catch (e) {}
      } else if (Array.isArray(item.commune)) {
        communesArray = item.commune;
      }
      
      communesArray.forEach(commune => {
        if (commune && commune.id_commune === selectedDistrict || 
            (commune.id_district && commune.id_district === selectedDistrict)) {
          if (!uniqueCommunes.has(commune.id_commune)) {
            uniqueCommunes.set(commune.id_commune, {
              id_commune: commune.id_commune,
              nom_commune: commune.nom_commune
            });
          }
        }
      });
    });
    return Array.from(uniqueCommunes.values());
  };

  const filterRegionsByData = (data) => {
    if (data && data.length > 0) {
      const uniqueRegions = extractUniqueRegions(data);
      setFilteredRegions(uniqueRegions);
    } else {
      setFilteredRegions(allRegions);
    }
  };

  useEffect(() => {
    if (datatable && datatable.length > 0) {
      filterRegionsByData(datatable);
      
      if (filter.region) {
        const uniqueDistricts = extractUniqueDistricts(datatable, filter.region);
        setDistricts(uniqueDistricts);
      } else {
        setDistricts([]);
      }
    } else {
      setFilteredRegions(allRegions);
      setDistricts([]);
      setCommunes([]);
    }
  }, [datatable, filter.region, allRegions]);

  useEffect(() => {
    if (datatable && datatable.length > 0 && filter.district) {
      const uniqueCommunes = extractUniqueCommunes(datatable, filter.district);
      setCommunes(uniqueCommunes);
    } else if (!filter.district) {
      setCommunes([]);
    }
  }, [datatable, filter.district]);

  const generateDateRange = (debut, fin) => {
    const startDate = new Date(debut);
    const endDate = new Date(fin);
    const dates = [];
    let currentDate = new Date(startDate);
    
    while (currentDate <= endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  const StatItem = ({ label, value, color }) => (
    <Grid item xs={12} sm={6} md={3}>
      <Box
        sx={{
          border: `2px solid ${color}.main`,
          borderRadius: 2, 
          padding: 2, 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: `0 4px 8px rgba(0, 0, 0, 0.1)`,
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: `${color}.lighter`, 
            boxShadow: `0 6px 12px rgba(0, 0, 0, 0.2)`,
          },
        }}
      >
        <Typography variant="body2" color="text.secondary" fontWeight="medium">
          {label}
        </Typography>

        <Box
          component="span"
          color={`${color}.main`}
          sx={{
            fontWeight: 'bold',
            fontSize: '1.5rem', 
            marginTop: 1, 
          }}
        >
          {value}
        </Box>
      </Box>
    </Grid>
  );

  const groupDaysByMonth = (dates) => {
    const months = {};
    dates.forEach(date => {
      const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      if (!months[monthKey]) {
        months[monthKey] = [];
      }
      months[monthKey].push(date.getDate());
    });
    return months;
  };

  const handleExportExcel = async () => {
    try {
      const dates = generateDateRange(filter.date_debut, filter.date_fin);
      const monthsGrouped = groupDaysByMonth(dates);
      
      const columnsHeader = [
        { header: 'Référence de la mission', key: 'reference', width: 15 },
        { header: 'Direction', key: 'direction', width: 15 },
        { header: 'Service', key: 'service', width: 15 },
        { header: 'Matricule', key: 'matricule', width: 15 },
        { header: 'Nom et prénom(s)', key: 'name', width: 30 },
        { header: 'Fonction', key: 'fonction', width: 25 },
        { header: 'Objet de la mission', key: 'title', width: 30 },
        { header: 'Direction de destination', key: 'direction', width: 20 },
        { header: 'Région de destination', key: 'lieu', width: 20 },
        { header: 'District de destination', key: 'lieu', width: 20 },
        { header: 'Commune de destination', key: 'lieu', width: 25 },
        { header: 'Date de départ', key: 'debut', width: 25 },
        { header: 'Date de retour', key: 'retour', width: 25 },
        { header: 'Statut', key: 'status', width: 25 },
      ];

      const monthKeys = Object.keys(monthsGrouped).sort((a, b) => {
        const [yearA, monthA] = a.split('-').map(Number);
        const [yearB, monthB] = b.split('-').map(Number);
        return yearA === yearB ? monthA - monthB : yearA - yearB;
      });

      monthKeys.forEach(monthKey => {
        const [year, month] = monthKey.split('-');
        monthsGrouped[monthKey].forEach(day => {
          const label = `${day}/${month}`;
          columnsHeader.push({ header: label, key: `${day}-${month}-${year}`, width: 8 });
        });
      });

      const data = [];
      const datacolor = [];

      datatable.forEach(ts => {
        const rowData = [
          ts.reference,
          ts.direction_code,
          ts.service_code,
          ts.registration_number,
          ts.nom,
          ts.function_code,
          ts.mission_title,
          ts.direction_dest,
          ts.region,
          ts.district,
          ts.commune,
          ts.date_debut,
          ts.date_fin,
          ts.final_state
        ];

        const rowColor = Array(14).fill('FFFFFFFF');
        const detailsMap = new Map();
        
        if (ts.details && Array.isArray(ts.details)) {
          ts.details.forEach(detail => {
            const key = `${detail.month_par_jour}-${detail.jour_par_jour}`;
            detailsMap.set(key, detail);
          });
        }

        monthKeys.forEach(monthKey => {
          const currentMonth = parseInt(monthKey.split('-')[1], 10);
          const monthDays = monthsGrouped[monthKey];

          monthDays.forEach(day => {
            const key = `${currentMonth}-${day}`;
            const matchingDetail = detailsMap.get(key);
            
            if (matchingDetail) {
              rowData.push(matchingDetail.lieufinal || '');
              rowColor.push(matchingDetail.final_state === 'En attente de validation' ? 'FFCECECE' :
                           matchingDetail.final_state === 'Validé' ? 'FF78B785' : 'FFFF0000');
            } else {
              rowData.push('');
              rowColor.push('FFFFFFFF');
            }
          });
        });

        data.push(rowData);
        datacolor.push(rowColor);
      });

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Planning des Missions');
      worksheet.columns = columnsHeader;

      data.forEach((rowData, rowIndex) => {
        const row = worksheet.addRow(rowData);
        row.eachCell({ includeEmpty: true }, (cell, colIndex) => {
          const color = datacolor[rowIndex]?.[colIndex - 1];
          if (color && color !== 'FFFFFFFF') {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: color.replace('#', 'FF') } };
            cell.font = { color: { argb: 'FF000000' } };
          }
        });
      });

      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
      headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4472C4' } };
      headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
      worksheet.eachRow((row) => { row.height = 20; });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileName = `planning_missions_${new Date().toISOString().split('T')[0]}.xlsx`;
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Erreur lors de l\'export Excel:', error);
      alert('Une erreur est survenue lors de l\'export. Veuillez réessayer.');
    }
  };

  function handleFilter() {
    if (!filter.reference && (!filter.date_debut || !filter.date_fin)) {
      setMessage({ 
        ...message, 
        open: true, 
        color: 'red', 
        messageInfo: "Veuillez saisir soit une référence de mission, soit une période (date début et date fin)" 
      });
      return;
    }

    setIsLoading(true);
    setOpenLoadingSimpleBackdrop(true);
    PlanningMissionService.getEtat(filter).then((result) => {
      if (result) {
        setIsLoading(false);
        setShowTable(true);
        setDatatable(result.data);
        setStatistique(result.stat);
        if (result.data.length === 0) {
          setMessage({ ...message, open: true, color: 'red', messageInfo: "Aucune donnée disponible pour le filtre sélectionné. Veuillez réinitialiser" });
        }
        setOpenLoadingSimpleBackdrop(false);
      } else {
        setIsLoading(false);
        setShowTable(false);
        setMessage({ ...message, open: true, color: 'red', messageInfo: result?.message || "Une erreur est survenue" });
      }
    });
  }

  function handlereinitiale() {
    setFilter({
      date_debut: '',
      date_fin: '',
      direction: [],
      destination: '',
      status: '',
      ligne: "missionaire",
      valeur: "direction",
      directionmiss: defaultDirection ? [defaultDirection.direction_id] : [],
      servicemiss: "",
      functionid: [],
      reference: '',
      region: '',
      district: '',
      commune: ''
    });
    setValdir([]);
    setSelectedDirection(defaultDirection || null);
    setSelectedService(null);
    setSelectedStatus(null);
    setSelectedFunctions([]);
    setSelectedRegion(null);
    setSelectedDistrict(null);
    setSelectedCommune(null);
    setDistricts([]);
    setCommunes([]);
    setShowTable(false);
    setDatatable([]);
    setStatistique([]);
    setServicedet({});
    setDirect(defaultDirection || {});

    // Recharger les services de la direction par défaut si disponible
    if (defaultDirection && defaultDirection.direction_id !== 'all') {
      PlanningMissionService.getServicelist([defaultDirection.direction_id]).then((res) => {
        if (res && res.data) {
          setService(res.data);
        }
      });
    } else {
      setService([]);
    }
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  useEffect(() => {
    const userData = localStorage.getItem('USER');
    if (userData) {
      UserService.getUserSummaryByUserId(userData)
        .then((result) => {
          if (result && result.data) {
            const dirpers = result.data.direction_id;
            PlanningMissionService.getDirection().then((result) => {
              if (result && result.data) {
                if (parseInt(dirpers, 10) === 1) {
                  const allOption = { id: 'all', name: 'Toutes', code: 'TOUTES', direction_id: 'all' };
                  setDirection([allOption, ...result.data]);
                  setDirectiondest(result.data);
                  // Pas de direction par défaut pour admin (ou on peut prendre la première)
                } else {
                  const filteredDirections = result.data.filter(ts => parseInt(ts.direction_id, 10) === parseInt(dirpers, 10));
                  setDirection(filteredDirections);
                  setDirectiondest(filteredDirections);
                  
                  // Définir la direction par défaut
                  if (filteredDirections.length > 0) {
                    const defaultDir = filteredDirections[0];
                    setDefaultDirection(defaultDir);
                    setSelectedDirection(defaultDir);
                    setDirect(defaultDir);
                    setFilter(prev => ({
                      ...prev,
                      directionmiss: [defaultDir.direction_id]
                    }));
                    
                    // Charger les services de la direction par défaut
                    PlanningMissionService.getServicelist([defaultDir.direction_id]).then((res) => {
                      if (res && res.data) {
                        setService(res.data);
                      }
                    });
                  }
                }
              }
            }).catch((error) => {
              console.error('Error fetching direction data:', error);
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching user summary:', error);
        });
    }

    PlanningMissionService.listfunction().then((result) => {
      if (result && result.data) {
        setListefonction(result.data);
      }
    }).catch((error) => {
      console.error('Error fetching fonction data:', error);
    });

    // Charger toutes les régions depuis l'API
    LocalisationMisService.getRegions().then((result) => {
      if (result && result.data) {
        setAllRegions(result.data);
        setFilteredRegions(result.data);
      }
    }).catch((error) => {
      console.error('Error fetching regions:', error);
    });
  }, []);

  return (
    <>
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <LoadingWithText openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      
      <Box style={{ padding: '24px', backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box>
            <Typography variant="h4" style={{ fontWeight: 'bold', color: '#1a237e' }}>
              Liste des missions
            </Typography>
          </Box>
          <Box display="flex" gap={2}>
            <Button
              variant="outlined"
              onClick={() => setFiltersExpanded(!filtersExpanded)}
              startIcon={filtersExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              style={{ borderRadius: '20px', textTransform: 'none', position: 'relative' }}
            >
              {filtersExpanded ? "Masquer les filtres" : "Afficher les filtres"}
              {getActiveFiltersCount() > 0 && !filtersExpanded && (
                <Badge badgeContent={getActiveFiltersCount()} color="error" style={{ marginLeft: 8 }} />
              )}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handlereinitiale}
              startIcon={<RestartAltIcon />}
              style={{ borderRadius: '20px', textTransform: 'none' }}
            >
              Réinitialiser
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: '#4caf50', color: 'white', borderRadius: '20px', textTransform: 'none' }}
              onClick={handleExportExcel}
              startIcon={<TableViewIcon />}
            >
              Export Excel
            </Button>
          </Box>
        </Box>

        <Box className={classes.infoBox}>
          <InfoIcon style={{ color: '#1976d2' }} />
          <Typography variant="body2" style={{ color: '#1976d2' }}>
            Vous pouvez rechercher soit par référence de mission, soit par période (dates début et fin). 
            Les deux champs ne sont pas obligatoires ensemble.
          </Typography>
        </Box>

        {getActiveFiltersCount() > 0 && (
          <Box mb={2}>
            <Typography variant="caption" color="textSecondary" style={{ fontWeight: 500 }}>
              Filtres actifs :
            </Typography>
            <Box mt={1} display="flex" flexWrap="wrap">
              {filter.reference && (
                <Chip
                  label={`Référence: ${filter.reference}`}
                  onDelete={() => removeFilter('reference')}
                  size="small"
                  style={{ marginRight: 8, marginBottom: 8 }}
                />
              )}
              {filter.date_debut && filter.date_fin && (
                <Chip
                  label={`Période: ${filter.date_debut} → ${filter.date_fin}`}
                  onDelete={() => removeFilter('dates')}
                  size="small"
                  style={{ marginRight: 8, marginBottom: 8 }}
                />
              )}
              {selectedDirection && selectedDirection.direction_id !== 'all' && (
                <Chip
                  label={`Direction missionnaire: ${selectedDirection.name}`}
                  onDelete={() => removeFilter('direction')}
                  size="small"
                  style={{ marginRight: 8, marginBottom: 8 }}
                />
              )}
              {selectedService && (
                <Chip
                  label={`Service: ${selectedService.name}`}
                  onDelete={() => removeFilter('service')}
                  size="small"
                  style={{ marginRight: 8, marginBottom: 8 }}
                />
              )}
              {valdir.length > 0 && (
                <Chip
                  label={`${valdir.length} direction(s) destination`}
                  onDelete={() => removeFilter('directiondest')}
                  size="small"
                  style={{ marginRight: 8, marginBottom: 8 }}
                />
              )}
              {selectedStatus && (
                <Chip
                  label={`Statut: ${selectedStatus.label}`}
                  onDelete={() => removeFilter('status')}
                  size="small"
                  style={{ marginRight: 8, marginBottom: 8 }}
                />
              )}
              {selectedFunctions.length > 0 && (
                <Chip
                  label={`${selectedFunctions.length} fonction(s)`}
                  onDelete={() => removeFilter('function')}
                  size="small"
                  style={{ marginRight: 8, marginBottom: 8 }}
                />
              )}
              {filter.region && selectedRegion && (
                <Chip
                  label={`Région: ${selectedRegion.nom_region}`}
                  onDelete={() => removeFilter('region')}
                  size="small"
                  style={{ marginRight: 8, marginBottom: 8 }}
                />
              )}
              {filter.district && selectedDistrict && (
                <Chip
                  label={`District: ${selectedDistrict.nom_district}`}
                  onDelete={() => removeFilter('district')}
                  size="small"
                  style={{ marginRight: 8, marginBottom: 8 }}
                />
              )}
              {filter.commune && selectedCommune && (
                <Chip
                  label={`Commune: ${selectedCommune.nom_commune}`}
                  onDelete={() => removeFilter('commune')}
                  size="small"
                  style={{ marginRight: 8, marginBottom: 8 }}
                />
              )}
            </Box>
          </Box>
        )}

        <Collapse in={filtersExpanded}>
          <Card className={classes.filterCard}>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Référence mission"
                    size="small"
                    variant="outlined"
                    value={filter.reference}
                    name="reference"
                    onChange={handleChange}
                    placeholder="Ex: MI-2024-001"
                    helperText="Recherche par référence exacte"
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Date début"
                    size="small"
                    variant="outlined"
                    type="date"
                    value={filter.date_debut}
                    name="date_debut"
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    helperText="Optionnel si référence fournie"
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Date fin"
                    size="small"
                    variant="outlined"
                    type="date"
                    value={filter.date_fin}
                    name="date_fin"
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    helperText="Optionnel si référence fournie"
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Autocomplete
                    onChange={handleChangeDirection}
                    value={selectedDirection}
                    options={direction}
                    getOptionLabel={(option) => `${option.name} (${option.code})`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Direction missionnaire"
                        fullWidth
                        size="small"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Autocomplete
                    onChange={handleChangeservice}
                    value={selectedService}
                    options={service}
                    getOptionLabel={(option) => `${option.name} (${option.code})`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Service missionnaire"
                        fullWidth
                        size="small"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Autocomplete
                    onChange={handleChangeDirdestination}
                    multiple
                    value={valdir}
                    options={directiondest}
                    getOptionLabel={(option) => `${option.name} (${option.code})`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Direction(s) destination"
                        fullWidth
                        size="small"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Autocomplete
                    onChange={handleChangestatus}
                    value={selectedStatus}
                    options={options}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Statut"
                        fullWidth
                        size="small"
                        variant="outlined"
                        placeholder="Sélectionnez un statut"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Autocomplete
                    multiple
                    onChange={handleChangefunction}
                    value={selectedFunctions}
                    options={listefonction}
                    getOptionLabel={(option) => `${option.name} (${option.code})`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Fonction"
                        fullWidth
                        size="small"
                        variant="outlined"
                        placeholder="Sélectionnez une ou plusieurs fonctions"
                      />
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          key={option.function_id}
                          label={`${option.name} (${option.code})`}
                          size="small"
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Autocomplete
                    onChange={handleChangeRegion}
                    options={filteredRegions}
                    value={selectedRegion}
                    getOptionLabel={(option) => option.nom_region || ''}
                    isOptionEqualToValue={(option, value) => option.id_region === value?.id_region}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Région"
                        fullWidth
                        size="small"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Autocomplete
                    onChange={handleChangeDistrict}
                    options={districts}
                    value={selectedDistrict}
                    getOptionLabel={(option) => option.nom_district || ''}
                    isOptionEqualToValue={(option, value) => option.id_district === value?.id_district}
                    disabled={!filter.region || loadingDistricts}
                    loading={loadingDistricts}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="District"
                        fullWidth
                        size="small"
                        variant="outlined"
                        disabled={!filter.region}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingDistricts && <CircularProgress color="inherit" size={20} />}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Autocomplete
                    onChange={handleChangeCommune}
                    options={communes}
                    value={selectedCommune}
                    getOptionLabel={(option) => option.nom_commune || ''}
                    isOptionEqualToValue={(option, value) => option.id_commune === value?.id_commune}
                    disabled={!filter.district || loadingCommunes}
                    loading={loadingCommunes}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Commune"
                        fullWidth
                        size="small"
                        variant="outlined"
                        disabled={!filter.district}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingCommunes && <CircularProgress color="inherit" size={20} />}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box display="flex" justifyContent="flex-end">
                    <LoadingButton
                      variant="contained"
                      color="primary"
                      onClick={handleFilter}
                      loading={isLoading}
                      startIcon={<SearchIcon />}
                      style={{ borderRadius: '20px', textTransform: 'none', paddingLeft: 24, paddingRight: 24 }}
                    >
                      Rechercher
                    </LoadingButton>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Collapse>

        <Box mb={4}>
          <Grid container spacing={3}>
            {Object.keys(statistique).length > 0 && (
              <>
                <StatItem 
                  label="Total missions" 
                  value={statistique['Nombre de missions planifiées'] || 0} 
                  color="primary"
                />
                <StatItem 
                  label="En attente de validation" 
                  value={statistique['En attente de validation'] || 0} 
                  color="warning"
                />
                <StatItem 
                  label="Validé" 
                  value={statistique['Validé'] || 0} 
                  color="success"
                />
                <StatItem 
                  label="Refusé" 
                  value={statistique['Refusé'] || 0} 
                  color="error"
                />
              </>
            )}
          </Grid>
        </Box>

        {showTable && (filter.reference || (filter.date_debut && filter.date_fin)) && (
          <DateRangeTableMission
            startDate={filter.date_debut ? new Date(filter.date_debut) : new Date()}
            endDate={filter.date_fin ? new Date(filter.date_fin) : new Date()}
            datatable={datatable}
          />
        )}
      </Box>
    </>
  );
}

export default MissionList;